import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { theme } from '../../theme';
import * as analytics from '../../lib/analytics';
import PasteInviteLinkModal from '../PasteInviteLinkModal';

type Variant = 'home' | 'empty-state';

interface Props {
  variant: Variant;
}

export default function NoGroupCard({ variant }: Props) {
  const navigate = useNavigate();
  const [showPasteModal, setShowPasteModal] = useState(false);
  const seenRef = useRef(false);

  useEffect(() => {
    if (seenRef.current) return;
    seenRef.current = true;
    analytics.track('group_card_viewed', { variant, platform: 'web' });
  }, [variant]);

  const handleCreate = () => {
    analytics.track('group_card_cta_clicked', { cta: 'create', variant, platform: 'web' });
    navigate('/groups/create');
  };

  const handlePasteLink = () => {
    analytics.track('group_card_cta_clicked', { cta: 'paste_link', variant, platform: 'web' });
    setShowPasteModal(true);
  };

  const wrapperStyle: React.CSSProperties = variant === 'home'
    ? {
        marginTop: theme.spacing.md,
        marginBottom: theme.spacing.md,
        padding: theme.spacing.lg,
        background: theme.colors.surface,
        borderRadius: theme.borderRadius.card,
        border: `2px solid ${theme.colors.primary}`,
        boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
      }
    : {
        padding: theme.spacing.lg,
        background: theme.colors.background,
        borderRadius: theme.borderRadius.card,
        border: `2px solid ${theme.colors.primary}`,
        textAlign: 'left',
      };

  return (
    <>
      <div style={wrapperStyle} data-testid="no-group-card">
        <div style={{ fontSize: 40, marginBottom: 12 }}>🏆</div>
        <h3 style={{ margin: '0 0 8px 0', color: theme.colors.text, fontFamily: theme.fonts.heading, fontSize: 20 }}>
          Tu equipo, un solo lugar
        </h3>
        <p style={{ margin: '0 0 16px 0', color: theme.colors.textSecondary, fontSize: 14, lineHeight: 1.5 }}>
          Creá un grupo y mantené a todos juntos para el partido semanal. Compartí el link, se unen solos, y todos los partidos quedan guardados con sus stats y logros.
        </p>
        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
          <button
            type="button"
            onClick={handleCreate}
            style={{
              padding: '12px 20px',
              background: theme.colors.primary,
              color: theme.colors.background,
              border: 'none',
              borderRadius: theme.borderRadius.button,
              fontWeight: 700,
              fontSize: 14,
              cursor: 'pointer',
              fontFamily: theme.fonts.body,
            }}
            data-testid="no-group-card-create"
          >
            Crear grupo
          </button>
          <button
            type="button"
            onClick={handlePasteLink}
            style={{
              padding: '12px 20px',
              background: 'transparent',
              color: theme.colors.primary,
              border: `1px solid ${theme.colors.primary}`,
              borderRadius: theme.borderRadius.button,
              fontWeight: 700,
              fontSize: 14,
              cursor: 'pointer',
              fontFamily: theme.fonts.body,
            }}
            data-testid="no-group-card-paste"
          >
            Tengo un link →
          </button>
        </div>
      </div>
      {showPasteModal && <PasteInviteLinkModal onClose={() => setShowPasteModal(false)} />}
    </>
  );
}
